import * as Styled from './styled'
import BackButton from 'common-components/BackButton'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { GenreThumbnail } from 'containers/SubSidebar/AudioContent/components/genre-thumbnail'
import { SoundsList } from 'containers/SubSidebar/AudioContent/components/sounds-list'
import { audioThunks } from 'store/features/audio/thunks'
import { audioSelectors } from 'store/features/audio/selectors'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'

interface IProps {
  activeGenreName: string
  onBackButtonClick: () => void
}

export const MusicLibSounds: React.FC<IProps> = ({
  activeGenreName,
  onBackButtonClick
}) => {
  const soundsGenresData = useSelector(audioSelectors.soundsGenres)
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  const activeGenreList = soundsGenresData.find(
    genre => genre.genre === activeGenreName
  )

  if (!activeGenreList) {
    return null
  }

  return (
    <Styled.MusicLibSoundsWrapper>
      <BackButton onClick={onBackButtonClick} label={activeGenreName} />

      {!isMobile && (
        <GenreThumbnail
          thumbnail={activeGenreList.thumbnail}
          activeGenreName={activeGenreName}
        />
      )}

      <SoundsList
        sounds={activeGenreList.sounds || []}
        paddingTop="8"
        onClickAddButton={() => {
          dispatch(audioThunks.getUsedLibSounds())
          !isMobile && onBackButtonClick()
        }}
        thumbnail={activeGenreList.thumbnail}
        activeGenreName={activeGenreName}
      />
    </Styled.MusicLibSoundsWrapper>
  )
}
